<template>
	<Autocomplete
		:params="{
			od: 'ASC',
			of: 'name',
			pageSize: 25,
		}"
		:icon="icon"
		:label="label"
		:endpoint="endpoint"
		:name="name"
		display-name="Meldungsart(en)"
		data-test="report-types"
		item-title="name"
		v-bind="$attrs"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: '',
		type: String,
	},
	label: {
		default: 'component.reports.category',
		type: String,
	},
	name: {
		default: 'report_types',
		type: String,
	},
	endpoint: {
		default: 'report_types',
		type: String,
	},
})
</script>

<style scoped></style>
